import { useState } from "react";
import SvgCommonStar from "../product-details-rate/SvgCommonStar";
interface Props {
  rating: number;
  setRating: (rating: number) => void;
}
const RateInput: React.FC<Props> = ({ rating, setRating }) => {
  const [hover, setHover] = useState(rating);
  return (
    <div className="d-flex" style={{ cursor: "pointer" }}>
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          onClick={() => setRating(index + 1)}
          onMouseEnter={() => setHover(index + 1)}
          onMouseLeave={() => setHover(rating)}
        >
          <SvgCommonStar large full={index < hover} />
        </div>
      ))}
    </div>
  );
};

export default RateInput;
